import clsx from "clsx";

import styles from "./ProfileSelectionButton.module.scss";
import Button from "../support/Button";
import AuthProfileTypeIcon from "../navBar/AuthProfileTypeIcon";
import HeadingText from "../support/HeadingText";
import BodyText from "../support/BodyText";

export default function ProfileSelectionButton() {
  return (
    <>
      <Button
        className={clsx(styles.button, {
          [styles.active]: false,
        })}
        variant="secondary"
      >
        <AuthProfileTypeIcon isCompany={false} />
        <HeadingText as="h3" color="heading-0">
          John Doe
        </HeadingText>
        <BodyText as="p" color="body-1">
          Enjoy and order food just for yourself
        </BodyText>
      </Button>
      <Button
        className={clsx(styles.button, {
          [styles.active]: true,
        })}
        variant="secondary"
      >
        <AuthProfileTypeIcon isCompany />
        <HeadingText as="h3" color="heading-0">
          Company
        </HeadingText>
        <BodyText as="p" color="body-1">
          Group order with your colleagues
        </BodyText>
      </Button>
    </>
  );
}
